var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { I18nService } from '@/services/i18n-service';
import { inject, injectable } from 'inversify';
import { DefaultPermissionDialogService, DefaultPermissionDialogServiceSymbol } from '@/presentation/components/default-permission-dialog/DefaultPermissionDialogService';
let DefaultPermissionCommandContribution = class DefaultPermissionCommandContribution {
    constructor(_i18nService, _defaultPermissionDialogService) {
        this._i18nService = _i18nService;
        this._defaultPermissionDialogService = _defaultPermissionDialogService;
    }
    registerCommands(commands) {
        commands.registerCommand({
            id: 'custom-field.default-permission-setting',
            icon: 'SolidSettings',
            label: this._i18nService.t('customField.actions.defaultPermissionSetting'),
        }, {
            execute: (context) => {
                return this._openDefaultPermissionDialog(context);
            },
        });
    }
    _openDefaultPermissionDialog(context) {
        // 从context中获取字段信息
        if (!context.fields || context.fields.length === 0) {
            console.warn('DefaultPermissionDialog: context.fields is empty');
            return;
        }
        // 获取第一个字段的ID
        const field = context.fields[0];
        const fieldId = field.field_id;
        // 使用弹窗服务打开弹窗，只传递字段ID
        this._defaultPermissionDialogService.open(fieldId);
    }
};
DefaultPermissionCommandContribution = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __param(1, inject(DefaultPermissionDialogServiceSymbol)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object, typeof (_b = typeof DefaultPermissionDialogService !== "undefined" && DefaultPermissionDialogService) === "function" ? _b : Object])
], DefaultPermissionCommandContribution);
export { DefaultPermissionCommandContribution };
